export default __webpack_public_path__ + "static/media/p_wdt_c_6.e8bc427a.mp3";